// redex/tasks/taskSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  tasksApis,
  createTasksApis,
  projectMenuApis,
  queryFromApis,
  clientMenuApis,
  mainMenuApis,
  submenu1Apis,
  submenu2Apis,
  submenu3Apis,
  submenu4Apis,
  tasksAssignApis,
  updateDevelopmentTasksApis,
  getTaskAssignmentApis,
  createStatusTrackerApis,
  getTaskDevelopmentApis,
  raisedbyDetailsApis,
  lastEndTimeApis,
  supportTeamTaskCreateApis,
  supportTeamTaskListApis,
  lastSyncDateTimeApis,
  historyListAPIs,
} from "./taskActions";

const initialState = {
  taskData: [], // This might become an object { data: [], totalRecords: ... } after fetching
  status: "idle",
  createStatus: "idle",
  error: null,
};

const tasksSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {
    logout(state) {
      state.taskData = [];
      state.status = "idle";
      state.createStatus = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // --- CREATE TASK ---
      .addCase(createTasksApis.pending, (state) => {
        state.createStatus = "loading";
        state.error = null;
      })
      .addCase(createTasksApis.fulfilled, (state, action) => {
        state.createStatus = "succeeded";
      })
      .addCase(createTasksApis.rejected, (state, action) => {
        state.createStatus = "failed";
        state.error = action.payload;
      })

      .addCase(supportTeamTaskCreateApis.pending, (state) => {
        state.createSupportTeamTaskStatus = "loading";
        state.error = null;
      })
      .addCase(supportTeamTaskCreateApis.fulfilled, (state, action) => {
        state.createSupportTeamTaskStatus = "succeeded";
      })
      .addCase(supportTeamTaskCreateApis.rejected, (state, action) => {
        state.createSupportTeamTaskStatus = "failed";
        state.error = action.payload;
      })

      // --- TASK Assign API---
      .addCase(tasksAssignApis.pending, (state) => {
        state.tasksAssignStatus = "loading";
        state.error = null;
      })
      .addCase(tasksAssignApis.fulfilled, (state, action) => {
        state.tasksAssignStatus = "succeeded";
      })
      .addCase(tasksAssignApis.rejected, (state, action) => {
        state.tasksAssignStatus = "failed";
        state.error = action.payload;
      })

      // --- FETCH LIST ---
      .addCase(tasksApis.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(tasksApis.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Store the full response (likely an object with pagination)
        state.taskData = action.payload?.data || action.payload || [];
      })
      .addCase(tasksApis.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // --- Query From ---
      .addCase(queryFromApis.fulfilled, (state, action) => {
        state.queryFromData = action.payload?.data || action.payload || [];
      })

      // --- Project Menu ---
      .addCase(projectMenuApis.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(projectMenuApis.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Store the full response (likely an object with pagination)
        state.projectMenuData = action.payload?.data || action.payload || [];
      })
      .addCase(projectMenuApis.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // --- CLIENT MENU (Dependent API) ---
      .addCase(clientMenuApis.pending, (state) => {
        state.clientStatus = "loading"; // Only turn on the client loader
        state.error = null;
      })
      .addCase(clientMenuApis.fulfilled, (state, action) => {
        state.clientStatus = "succeeded";
        state.clientMenuData = action.payload?.data || action.payload || [];
      })
      .addCase(clientMenuApis.rejected, (state, action) => {
        state.clientStatus = "failed";
        state.error = action.payload;
      })

      // --- MAIN MENU (Dependent API) ---
      .addCase(mainMenuApis.pending, (state) => {
        state.mainMenuStatus = "loading"; // Only turn on the mainMenu loader
        state.error = null;
      })
      .addCase(mainMenuApis.fulfilled, (state, action) => {
        state.mainMenuStatus = "succeeded";
        state.mainMenuData = action.payload?.data || action.payload || [];
      })
      .addCase(mainMenuApis.rejected, (state, action) => {
        state.mainMenuStatus = "failed";
        state.error = action.payload;
      })

      // --- SUBMENU 1 MENU (Dependent API) ---
      .addCase(submenu1Apis.pending, (state) => {
        state.submenu1Status = "loading"; // Only turn on the submenu1 loader
        state.error = null;
      })
      .addCase(submenu1Apis.fulfilled, (state, action) => {
        state.submenu1Status = "succeeded";
        state.submenu1Data = action.payload?.data || action.payload || [];
      })
      .addCase(submenu1Apis.rejected, (state, action) => {
        state.submenu1Status = "failed";
        state.error = action.payload;
      })

      // --- SUBMENU 2 (Dependent API) ---
      .addCase(submenu2Apis.pending, (state) => {
        state.submenu2Status = "loading"; // Only turn on the submenu2 loader
        state.error = null;
      })
      .addCase(submenu2Apis.fulfilled, (state, action) => {
        state.submenu2Status = "succeeded";
        state.submenu2Data = action.payload?.data || action.payload || [];
      })
      .addCase(submenu2Apis.rejected, (state, action) => {
        state.submenu2Status = "failed";
        state.error = action.payload;
      })

      // --- SUBMENU 3 (Dependent API) ---
      .addCase(submenu3Apis.pending, (state) => {
        state.submenu3Status = "loading"; // Only turn on the submenu2 loader
        state.error = null;
      })
      .addCase(submenu3Apis.fulfilled, (state, action) => {
        state.submenu3Status = "succeeded";
        state.submenu3Data = action.payload?.data || action.payload || [];
      })
      .addCase(submenu3Apis.rejected, (state, action) => {
        state.submenu3Status = "failed";
        state.error = action.payload;
      })

      // --- SUBMENU 4 (Dependent API) ---
      .addCase(submenu4Apis.pending, (state) => {
        state.submenu4Status = "loading"; // Only turn on the submenu2 loader
        state.error = null;
      })
      .addCase(submenu4Apis.fulfilled, (state, action) => {
        state.submenu4Status = "succeeded";
        state.submenu4Data = action.payload?.data || action.payload || [];
      })
      .addCase(submenu4Apis.rejected, (state, action) => {
        state.submenu4Status = "failed";
        state.error = action.payload;
      })

      .addCase(updateDevelopmentTasksApis.pending, (state) => {
        state.updateDevelopmentTaskStatus = "loading";
        state.error = null;
      })
      .addCase(updateDevelopmentTasksApis.fulfilled, (state, action) => {
        state.updateDevelopmentTaskStatus = "succeeded";
        // Optional: Update the specific task in taskData list if needed
        // state.taskData = state.taskData.map(task =>
        //    task.id === action.payload.id ? action.payload : task
        // );
      })
      .addCase(updateDevelopmentTasksApis.rejected, (state, action) => {
        state.updateDevelopmentTaskStatus = "failed";
        state.error = action.payload;
      })

      .addCase(createStatusTrackerApis.pending, (state) => {
        state.createStatusTracker = "loading";
        state.error = null;
      })
      .addCase(createStatusTrackerApis.fulfilled, (state, action) => {
        state.createStatusTracker = "succeeded";
      })
      .addCase(createStatusTrackerApis.rejected, (state, action) => {
        state.createStatusTracker = "failed";
        state.error = action.payload;
      })

      .addCase(getTaskAssignmentApis.pending, (state) => {
        state.getTaskAssignmentStatus = "loading"; // Only turn on the submenu2 loader
        state.error = null;
      })
      .addCase(getTaskAssignmentApis.fulfilled, (state, action) => {
        state.getTaskAssignmentStatus = "succeeded";
        state.getTaskAssignmentData =
          action.payload?.data || action.payload || [];
      })
      .addCase(getTaskAssignmentApis.rejected, (state, action) => {
        state.getTaskAssignmentStatus = "failed";
        state.error = action.payload;
      })

      .addCase(getTaskDevelopmentApis.pending, (state) => {
        state.getTaskDevelopmentStatus = "loading";
        state.error = null;
      })
      .addCase(getTaskDevelopmentApis.fulfilled, (state, action) => {
        state.getTaskDevelopmentStatus = "succeeded";
        state.getTaskDevelopmentData =
          action.payload?.data || action.payload || [];
      })
      .addCase(getTaskDevelopmentApis.rejected, (state, action) => {
        state.getTaskDevelopmentStatus = "failed";
        state.error = action.payload;
      })

      .addCase(raisedbyDetailsApis.pending, (state) => {
        state.getRaisedbyDetailsStatus = "loading";
        state.error = null;
      })
      .addCase(raisedbyDetailsApis.fulfilled, (state, action) => {
        state.getRaisedbyDetailsStatus = "succeeded";
        state.getRaisedbyDetailsData =
          action.payload?.data || action.payload || [];
      })
      .addCase(raisedbyDetailsApis.rejected, (state, action) => {
        state.getRaisedbyDetailsStatus = "failed";
        state.error = action.payload;
      })

      .addCase(lastEndTimeApis.pending, (state) => {
        state.getLastEndTimeStatus = "loading";
        state.error = null;
      })
      .addCase(lastEndTimeApis.fulfilled, (state, action) => {
        state.getLastEndTimeStatus = "succeeded";
        state.getLastEndTimeData = action.payload?.data || action.payload || [];
      })
      .addCase(lastEndTimeApis.rejected, (state, action) => {
        state.getLastEndTimeStatus = "failed";
        state.error = action.payload;
      })

      .addCase(supportTeamTaskListApis.pending, (state) => {
        state.getSupportTeamTaskListStatus = "loading";
        state.error = null;
      })
      .addCase(supportTeamTaskListApis.fulfilled, (state, action) => {
        state.getSupportTeamTaskListStatus = "succeeded";
        state.getSupportTeamTaskListData =
          action.payload?.data || action.payload || [];
      })
      .addCase(supportTeamTaskListApis.rejected, (state, action) => {
        state.getSupportTeamTaskListStatus = "failed";
        state.error = action.payload;
      })

      .addCase(historyListAPIs.pending, (state) => {
        state.historyListStatus = "loading";
        state.error = null;
      })
      .addCase(historyListAPIs.fulfilled, (state, action) => {
        state.historyListStatus = "succeeded";
        state.historyListData = action.payload?.data || action.payload || [];
      })
      .addCase(historyListAPIs.rejected, (state, action) => {
        state.historyListStatus = "failed";
        state.error = action.payload;
      });
  },
});

export const { logout } = tasksSlice.actions;
export default tasksSlice.reducer;
